import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import { BehaviorSubject } from 'rxjs';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';

interface IAgCheckboxParams extends ICellRendererParams {
  getDisabledState?: () => boolean;
}

@Component({
  template: `
    <div class="flex items-center justify-center" style="height: 30px">
      <aux-checkbox
        [disabled]="(disabled$ | async) === true"
        [(ngModel)]="val"
        [indeterminate]="indeterminate"
        (ngModelChange)="onChange($event)"
      ></aux-checkbox>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgCheckboxComponent implements ICellRendererAngularComp {
  val: any;

  params!: IAgCheckboxParams;

  disabled$ = new BehaviorSubject(false);

  indeterminate = false;

  refresh(): boolean {
    return false;
  }

  agInit(params: IAgCheckboxParams) {
    this.params = params;
    this.val = params.value;

    if (params.value === 'indeterminate') {
      this.indeterminate = true;
      this.val = false;
    }

    if (params.getDisabledState) {
      this.disabled$.next(params.getDisabledState());
    }
  }

  onChange(e: any) {
    this.indeterminate = false;
    if (this.params.colDef?.field) {
      this.params.node.setDataValue(this.params.colDef.field, e);
    }
    this.params.node.setSelected(e);
  }
}
